import { createService, z } from '@betty/toolkit/api';

const LoginResponseSchema = z.union([
  z.object({
    authorizationCode: z.string().optional(),
    requireTwoFactorVerification: z.literal(false),
    token: z.string().optional(),
  }),
  z.object({
    authorizationCode: z.string().optional(),
    requireTwoFactorVerification: z.literal(true),
    token: z.string(),
  }),
]);

const ValidateMFAResponseSchema = z.object({
  authorizationCode: z.string(),
});

const GetTokenResponseSchema = z.object({
  id_token: z.string(),
  access_token: z.string(),
  expires_in: z.number(),
  token_type: z.string(),
  refresh_token: z.string(),
  scope: z.string(),
});

export type GetTokenResponse = z.infer<typeof GetTokenResponseSchema>;

export default createService({
  login: {
    method: 'POST',
    url: '/auth/login',
    public: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    credentials: 'include',
    responseSchema: LoginResponseSchema,
  },
  loginCompleted: {
    method: 'POST',
    url: ({ userId }: { userId: string }) =>
      `/Accounts/${userId}/sessions/logincompleted`,
    responseSchema: z.object({}).optional(),
  },
  validateMFA: {
    method: 'POST',
    url: '/auth/mfa/validate',
    public: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    responseSchema: ValidateMFAResponseSchema,
  },
  getToken: {
    method: 'POST',
    url: '/connect/token',
    public: true,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    responseSchema: GetTokenResponseSchema,
  },
  resendMFACode: {
    method: 'POST',
    url: '/auth/mfa/resend',
    public: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    responseSchema: z.object({ token: z.string() }),
  },
  resetPasswordLink: {
    method: 'POST',
    url: '/auth/passwords/resetLink',
    public: true,
    responseSchema: z.object({}).optional(),
  },
  resetPassword: {
    method: 'POST',
    url: '/auth/passwords/reset',
    public: true,
    responseSchema: z.object({}).optional(),
  },
  changePassword: {
    method: 'PUT',
    url: '/auth/passwords/change',
    responseSchema: z.object({}).optional(),
  },
  logout: {
    method: 'POST',
    url: '/auth/logout',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    credentials: 'include',
    responseSchema: z.object({}).optional(),
  },
  siteLocation: {
    method: 'POST',
    url: '/siteLocation',
    responseSchema: z.any(),
  },
});
